export default __webpack_public_path__ + "static/media/interactive-classes.faaa0bcd.svg";